import React from 'react';
import { managementTaskDetailPath } from './managementActionCenter';

export function ManagementTaskActionCard({ item, vertical, navigate, kind = 'todo' }) {
  if (!item?.taskId) return null;
  const countLabel = item.count === 1 ? '1 subtask' : `${item.count} subtasks`;
  const prefix = kind === 'approve' ? 'Approve' : 'Management Task';

  return (
    <div
      className="flex items-center justify-between border border-gray-200 rounded-lg p-2 cursor-pointer hover:bg-gray-50 mb-2"
      onClick={() =>
        navigate(managementTaskDetailPath(vertical, item.taskId))
      }
    >
      <div className="flex items-center gap-2 min-w-0">
        <div className="w-6 h-6 rounded-full bg-[#346C75] text-white flex items-center justify-center text-xs font-semibold shrink-0">
          M
        </div>
        <span className="text-sm font-medium text-gray-800 truncate">
          {kind !== 'approve' && item.returned
            ? `returned : ${item.title}`
            : `${prefix} | ${item.title} | ${countLabel}`}
        </span>
      </div>
    </div>
  );
}

export default ManagementTaskActionCard;
